import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDebouncedAction } from "../../../../../../helpers/commonFunction";
import { AppState } from "../../../../../../stateManager/store";
import { getValue, getComponents } from "../../helpers";
import { onChange } from "./helpers/on-change"

const DEFAULT_MARGIN: string = "properties.styles.$deviceType.margin";
const DEFAULT_MARGIN_TOP = "properties.styles.$deviceType.marginTop";
const DEFAULT_MARGIN_RIGHT = "properties.styles.$deviceType.marginRight";
const DEFAULT_MARGIN_BOTTOM = "properties.styles.$deviceType.marginBottom";
const DEFAULT_MARGIN_LEFT = "properties.styles.$deviceType.marginLeft";

type Props = {
  label?: string;
  isCheckedIn?: boolean;
  defaultValue?: string;
  isExpandMargin?: boolean;
}
export const Margin = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType, isCoreV3, computedStyles } = useSelector((state: AppState) => state.formJson)
  const { isCheckedIn, defaultValue, label, isExpandMargin } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useDebouncedAction(defaultValue, 500);
  const component = components[selectedElementId];

  useEffect(() => {
    if (isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_MARGIN.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      } else if (
        computedStyles.marginTop === computedStyles.marginRight &&
        computedStyles.marginTop === computedStyles.marginBottom &&
        computedStyles.marginTop === computedStyles.marginLeft
      ) {
        const overallMargin = parseInt(computedStyles.marginTop).toString();
        setValue(overallMargin);
        setOldValue(overallMargin);
      } else {
        setValue("");
        setOldValue("");
      }
    } else if (!isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_MARGIN.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      }
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_MARGIN.split("."), deviceType), computedStyles]);

  return (
    <>
      <label
        htmlFor="margin"
        style={{ fontSize: "11px", color: "#282B31" }}
        className="panel-label"
      >
        {label}
      </label>
      <input
        style={{ cursor: !isCheckedIn || isExpandMargin ? "not-allowed" : "auto", width: "140px" }}
        disabled={!isCheckedIn || isExpandMargin}
        data-test-id={`${component?.type}-overall_margin`}
        type="number"
        id="margin"
        value={value}
        className="panel-input"
        placeholder="0"
        onChange={e => {
          const value = e.target.value;
          setValue(value, () => onChange({
            path: DEFAULT_MARGIN,
            value,
            oldValue,
            setOldValue,
            selectedElementId
          }))
        }}
      />
    </>
  )
};


export const MarginTop = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType, isCoreV3, computedStyles } = useSelector((state: AppState) => state.formJson)
  const { defaultValue } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useDebouncedAction(defaultValue, 500);
  const component = components[selectedElementId];

  useEffect(() => {
    if (isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_MARGIN_TOP.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      } else if (computedStyles.marginTop) {
        const computedValue = parseInt(computedStyles.marginTop, 10).toString();
        setValue(computedValue)
        setOldValue(computedValue)
      }
    } else if (component) {
      const previousValue = getValue(component, DEFAULT_MARGIN_TOP.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      }
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_MARGIN_TOP.split("."), deviceType), computedStyles]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        height: "28px",
        width: "34px",
        border: "2px solid #7D84924D",
        borderRadius: "2px",
        borderTopRightRadius: "3.5px",
        borderTopLeftRadius: "3.5px",
        borderTop: "none",
        marginLeft: "7px"
      }}
    >
      <input
        type="number"
        data-test-id={`${component?.type}-margin_top`}
        id="margintop"
        style={{
          position: "absolute",
          height: "28px",
          width: "34px",
          borderWidth: "2.3px",
          borderTopColor:  (value && value != 0) ? "rgba(241, 114, 46, 1)" : "#052f35 ",
          borderStyle: "solid",
          borderLeft: "none",
          borderRadius: "4px",
          borderRight: "none",
          borderBottom: "none",
          background: "none",
          outline: "none",
        }}
        className="text-gray-900 text-lg p-2 text-center dark:text-white focus:outline-none cursor-pointer"
        placeholder="0"
        value={value}
        onChange={e => {
          const value = e.target.value;
          setValue(value, () => onChange({
            path: DEFAULT_MARGIN_TOP,
            value,
            oldValue,
            setOldValue,
            selectedElementId
          }))
        }}
      />
    </div>
  )
}

export const MarginRight = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType, isCoreV3, computedStyles } = useSelector((state: AppState) => state.formJson)
  const { defaultValue } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useDebouncedAction(defaultValue, 500);
  const component = components[selectedElementId];

  useEffect(() => {
    if (isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_MARGIN_RIGHT.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      } else if (computedStyles.marginRight) {
        const computedValue = parseInt(computedStyles.marginRight, 10).toString();
        setValue(computedValue)
        setOldValue(computedValue)
      }
    } else if (!isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_MARGIN_RIGHT.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      }
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_MARGIN_RIGHT.split("."), deviceType), computedStyles]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        height: "28px",
        width: "34px",
        border: "2px solid #7D84924D",
        borderRadius: "2px",
        borderTopRightRadius: "3.5px",
        borderBottomRightRadius: "3.5px",
        borderRight: "none",
        marginLeft: "7px"
      }}
    >
      <input
        type="number"
        id="marginright"
        data-test-id={`${component?.type}-margin_right`}
        style={{
          position: "absolute",
          height: "28px",
          width: "34px",
          borderWidth: "2.3px",
          borderStyle: "solid",
          borderRadius: "4px",
          borderRightColor: (value && value != 0) ? "rgba(241, 114, 46, 1)" : "#052f35 ",
          borderBottom: "none",
          borderLeftWidth: "2.3px",
          borderLeftColor: "transparent",
          background: "none",
          borderTop: "none",
          outline: "none",
        }}
        className="text-gray-900 text-lg p-2 text-center dark:text-white focus:outline-none cursor-pointer"
        placeholder="0"
        value={value}
        onChange={e => {
          const value = e.target.value;
          setValue(value, () => onChange({
            path: DEFAULT_MARGIN_RIGHT,
            value,
            oldValue,
            setOldValue,
            selectedElementId
          }))
        }}
      />
    </div>
  )
}

export const MarginBottom = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType, isCoreV3, computedStyles } = useSelector((state: AppState) => state.formJson)
  const { defaultValue } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useDebouncedAction(defaultValue, 500);
  const component = components[selectedElementId];

  useEffect(() => {
    if (isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_MARGIN_BOTTOM.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      } else if (computedStyles.marginBottom) {
        const computedValue = parseInt(computedStyles.marginBottom, 10).toString();
        setValue(computedValue)
        setOldValue(computedValue)
      }
    } else if (!isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_MARGIN_BOTTOM.split("."), deviceType);
      setValue(previousValue)
      setOldValue(previousValue)
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_MARGIN_BOTTOM.split("."), deviceType), computedStyles]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        height: "28px",
        width: "34px",
        border: "2px solid #7D84924D",
        borderRadius: "2px",
        borderBottomRightRadius: "3.5px",
        borderBottomLeftRadius: "3.5px",
        borderBottom: "none",
        marginLeft: "7px"
      }}
    >
      <input
        type="number"
        id="marginbottom"
        data-test-id={`${component?.type}-margin_bottom`}
        style={{
          position: "absolute", left: "-1.5px",
          height: "28px",
          width: "34px",
          borderWidth: "2.3px",
          borderStyle: "solid",
          borderRadius: "4px",
          borderBottomColor: (value && value != 0) ? "rgba(241, 114, 46, 1)" : "#052f35 ",
          borderRight: "none",
          borderTopWidth: "2.3px",
          borderTopColor: "transparent",
          borderLeft: "none",
          background: "none",
          outline: "none",
        }}
        className="text-gray-900 text-lg p-2 text-center dark:text-white focus:outline-none cursor-pointer"
        placeholder="0"
        value={value}
        onChange={e => {
          const value = e.target.value;
          setValue(value, () => onChange({
            path: DEFAULT_MARGIN_BOTTOM,
            value,
            oldValue,
            setOldValue,
            selectedElementId
          }))
        }}
      />
    </div>
  )
}

export const MarginLeft = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType, isCoreV3, computedStyles } = useSelector((state: AppState) => state.formJson)
  const { defaultValue } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useDebouncedAction(defaultValue, 500);
  const component = components[selectedElementId];

  useEffect(() => {
    if (isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_MARGIN_LEFT.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      } else if (computedStyles.marginLeft) {
        const computedValue = parseInt(computedStyles.marginLeft, 10).toString();
        setValue(computedValue)
        setOldValue(computedValue)
      }
    } else if (!isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_MARGIN_LEFT.split("."), deviceType);
      setValue(previousValue)
      setOldValue(previousValue)
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_MARGIN_LEFT.split("."), deviceType), computedStyles]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        height: "28px",
        width: "34px",
        border: "2px solid #7D84924D",
        borderRadius: "2px",
        borderTopLeftRadius: "3.5px",
        borderBottomLeftRadius: "3.5px",
        borderLeft: "none",
        marginLeft: "7px"
      }}
    >
      <input
        type="number"
        id="marginleft"
        data-test-id={`${component?.type}-margin_left`}
        style={{
          position: "absolute",
          height: "28px",
          width: "34px",
          borderWidth: "2.3px",
          borderStyle: "solid",
          borderRadius: "4px",
          borderLeftColor: (value && value != 0) ? "rgba(241, 114, 46, 1)" : "#052f35 ",
          borderBottom: "none",
          borderRightWidth: "2.3px",
          borderRightColor: "transparent",
          background: "none",
          borderTop: "none",
          outline: "none",
        }}
        className="text-gray-900 text-lg p-2 text-center dark:text-white focus:outline-none cursor-pointer"
        placeholder="0"
        value={value}
        onChange={e => {
          const value = e.target.value;
          setValue(value, () => onChange({
            path: DEFAULT_MARGIN_LEFT,
            value,
            oldValue,
            setOldValue,
            selectedElementId
          }))
        }}
      />
    </div>
  )
}
